import { Maybe, structuredMaybeDecoder } from '@execonline-inc/structured-maybe';
import { Decoder, array, dateISO, field, number, string, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../Resource/Decoders';
import { Resource } from '../../../../Resource/Types';

// Base types
interface RecentlyLoggedInPayload {
  id: number;
  name: string;
  currentSignInAt: Maybe<Date>;
}

// A single user with their links
export type RecentlyLoggedInResource = Resource<RecentlyLoggedInPayload>;

// Collection of users wrapped in a resource
export type RecentlyLoggedInCollectionResource = Resource<RecentlyLoggedInResource[]>;

// Decoders
const recentlyLoggedInPayloadDecoder: Decoder<RecentlyLoggedInPayload> = succeed({})
  .assign('id', field('id', number))
  .assign('name', field('name', string))
  .assign('currentSignInAt', field('current_sign_in_at', structuredMaybeDecoder(dateISO)));

const recentlyLoggedInResourceDecoder: Decoder<RecentlyLoggedInResource> = resourceDecoder(
  recentlyLoggedInPayloadDecoder,
);

export const recentlyLoggedInCollectionResourceDecoder: Decoder<RecentlyLoggedInCollectionResource> =
  resourceDecoder(array(recentlyLoggedInResourceDecoder));
